import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createReadyMStkEntry = createAsyncThunk('createReadyMStkEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertReadyMadeStk`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateReadyMStkEntry = createAsyncThunk('updateReadyMStkEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateReadyMadeStk`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchReadyMStkData = createAsyncThunk('fetchReadyMStkData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getReadyMadeStockList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleReadyMStk = createAsyncThunk('fetchSingleReadyMStk', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getReadyMadeStockList&readyId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleReadyMStk = createAsyncThunk('deleteSingleReadyMStk', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteReadyMadeStk&readyId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});




const readyMStkSlice = createSlice({
    name: 'ReadyMStkData',
    initialState: {
        isLoading: false,
        readyMStk: null,
        deleteReadyMStk: null,
        singleReadyMStk: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchReadyMStkData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchReadyMStkData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.readyMStk = action.payload;
        });
        builder.addCase(fetchReadyMStkData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleReadyMStk.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleReadyMStk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteReadyMStk = action.payload;
        });
        builder.addCase(deleteSingleReadyMStk.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleReadyMStk.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleReadyMStk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleReadyMStk = action.payload;
        });
        builder.addCase(fetchSingleReadyMStk.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default readyMStkSlice.reducer;
